import processReport from '@/assets/js/report/order'
import processZoneReport from '@/assets/js/report/order_zone'
export default {
  methods: {
    async genereateReportContent (getObj, reportType, commercialInvoiceId) {
      // let getObj = this.listPayloadObj.list ? this.listPayloadObj.list.find(x => x.id === id) : {}
      if (!getObj) getObj = {}
      let customerLang = (getObj && getObj.customerlanguage) ? getObj.customerlanguage : this.$i18n.locale
      let lang = reportType === 4 ? this.$i18n.messages['en'].message : this.$i18n.messages[customerLang].message
      let headers = []
      if (getObj) {
        headers = [{ text: lang.orders.productNo, value: 'number', width: '21%' },
          { text: lang.customer.name, value: 'producttext', width: '41%' },
          { text: lang.invoice.qty, value: 'qty', width: '6%' },
          { text: lang.orders.price, value: 'price', width: '10%' },
          { text: `${lang.product.discount}%`, value: 'discount', width: '8%' },
          { text: lang.common.total, value: 'total', width: '12%' },
          { text: 'DG', value: 'dg' }
        ]
        if (reportType === 7) {
          headers = [{ text: lang.orders.productNo, value: 'number', width: '25%' },
            { text: lang.customer.name, value: 'producttext', width: '45%' },
            { text: lang.invoice.qty, value: 'qty', width: '6%' },
            { text: lang.orders.price, value: 'price', width: '10%' },
            { text: lang.common.total, value: 'total', width: '12%' }
          ]
        }
        let products = await this.getOrderProducts(getObj.id, reportType, commercialInvoiceId)
        // calculation of products
        let totalVat = 0
        let totalExVat = 0
        products.map(x => {
          let getVat = +this.$formatter.replaceCommaWithDot(x.vat)
          let getExVat = +this.$formatter.replaceCommaWithDot(x.total)
          totalVat = totalVat + ((getExVat) * (getVat / 100))
          totalExVat += getExVat
          // Normalize null and empty string zones to null for consistent grouping
          if (x.zone === '' || x.zone === null || x.zone === undefined) {
            x.zone = null
          }
          return x
        })
        const productsList = this.$formatter.cloneVariable(products)
        products = this.$_groupBy(products, 'zone')
        getObj.totalexvat = this.$formatter.replaceDotWithComma(totalExVat)
        getObj.totalvat = this.$formatter.replaceDotWithComma(totalVat)
        getObj.totalsum = this.$formatter.replaceDotWithComma(totalExVat + totalVat)
        let translationData = {
          confirm: (getObj.type === 'offer') ? lang.layout.offer : lang.common.orderConfirm,
          number: (getObj.type === 'offer') ? lang.order.offerNumber : lang.order.orderNumber,
          customer: lang.order.customer,
          contact: lang.order.yourContactPerson,
          deliveryaddress: lang.orders.deliveryAddress,
          responsible: lang.deviations.responsible,
          ourreference: lang.orders.ourReference,
          yourreference: lang.orders.yourReference,
          offerdate: lang.orders.offerDate,
          offerdue: lang.orders.offerDueDate,
          orderdate: lang.whOrder.orderDate,
          deliverydate: lang.order.shippingDate,
          total: lang.orders.totalSum,
          totalExVat: lang.orders.totalExVat,
          totalVal: lang.common.total,
          shipment: lang.customer.shipmentReport,
          paymentTerm: lang.order.paymentTerms,
          deliveryTerm: lang.order.deliveryTerm,
          invoiceTo: lang.orders.invoiceTo,
          deliveryAddress: lang.orders.deliveryAddress,
          invoiceAddress: lang.orders.invoiceAddress,
          days: lang.common.days,
          totalVAT: lang.order.totalVAT,
          currency: lang.product.currency,
          restorder: lang.orders.restOrderFor,
          delivery: lang.customer.delivery,
          yourOrderNumber: lang.orders.yourOrderNumber,
          saleRef: lang.invoiceReport.saleRef,
          customerNum: lang.unimicro.customerNumber,
          deliveryTime: lang.orders.deliveryTime,
          labeled: lang.order.labeled
        }
        let getBase64Content = ''
        if (reportType === 4) translationData.confirm = lang.common.commercialInvoice
        if (reportType === 7) {
          if (getObj.type === 'offer') {
            translationData.confirm = lang.layout.offer
          } else {
            translationData.confirm = lang.order.confirmationWithZone
          }
          var zoneSorted = Object.fromEntries(
            Object.entries(products).sort(([, a], [, b]) => a - b)
          )
          getBase64Content = processZoneReport(headers, zoneSorted, getObj, translationData, getObj.restcreatedfromnumber, reportType)
        } else {
          getBase64Content = processReport(headers, products, getObj, translationData, getObj.restcreatedfromnumber, reportType, productsList)
        }
        return getBase64Content
      }
    },
    getOrderProducts (id, type, commercialInvoiceId) {
      let filterQuery = `orderid eq '${id}'`
      if (commercialInvoiceId) {
        filterQuery = `orderid eq '${id}' and commercialinvoiceid eq '${commercialInvoiceId}'`
      }
      return new Promise((resolve, reject) => {
        let query = {
          expand: [{
            'select': ['number', 'name', 'available', 'hs', 'isinformation'],
            'model': 'Product',
            'on_field': 'id',
            'on_parent_field': 'productid'
          }, {
            'select': ['name'],
            'model': 'ProductUnit',
            'on_field': 'id',
            'on_parent_field': 'unitid'
          }],
          order_by: {
            field: 'alignindex',
            asc_or_desc: 'asc'
          },
          filter: filterQuery
        }
        this.$_executeApi('post', 'ordermaterials/query', query)
          .then((response) => {
            if (response.data) {
              let transformData = { number: { list: ['qty', 'price', 'discount', 'vat', 'total'], format: 'replaceDotWithComma' } }
              let itemsObj = this.$_formatListModel(response.data, transformData)
              if (commercialInvoiceId) {
                itemsObj = itemsObj.filter(x => !x.packageid && !x.mainpackageid && (x.ispackage || x.pickedqty > 0))
              } else {
                itemsObj = itemsObj.filter(x => !x.packageid && !x.orderindex && !x.mainpackageid)
              }
              itemsObj.map(x => {
                if (commercialInvoiceId) {
                  let qtyField = x.ispackage ? x.qty : x.pickedqty
                  x.qty = qtyField
                  const getPicked = +this.$formatter.replaceCommaWithDot(x.qty)
                  const getPrice = +this.$formatter.replaceCommaWithDot(x.price)
                  const getDiscount = +this.$formatter.replaceCommaWithDot(x.discount)
                  let total = getPicked * getPrice
                  x.total = this.$formatter.replaceDotWithComma(total)
                  x.totalFormat = total
                  if (getDiscount) {
                    let discountedValue = (total * getDiscount) / 100
                    let getValue = total - discountedValue
                    x.total = this.$formatter.replaceDotWithComma(getValue)
                  }
                }
                x.totalFormat = this.$formatter.replaceCommaWithDot(x.total)
                const formattedQty = +this.$formatter.replaceCommaWithDot(x.qty)
                x.qty = this.$formatter.replaceDotWithCommaIfHasDecimal(formattedQty)
                if (x.product_isinformation) {
                  x.qty = ''
                  x.price = ''
                  x.total = ''
                }
                if (x.isfreight) {
                  x.producttext = 'Frakt'
                  x.number = '1000'
                }
                return x
              })
              resolve(itemsObj)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
